import ActionTypes from "../constants/action_types";

export default function clearError() {
  return {
    type: ActionTypes.ERROR_CLEAR.SUCCESS,
  };
}
